import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"

function LogoStream() {
  const logos = [
    "/brand-logos/all-bar-one.png",
    "/brand-logos/browns.png",
    "/brand-logos/ember.png",
    "/brand-logos/ego.png",
    "/brand-logos/harvester.png",
    "/brand-logos/innkeepers-lodge.png",
    "/brand-logos/miller-and-carter.png",
    "/brand-logos/nicholsons.png",
    "/brand-logos/oneills.png",
    "/brand-logos/premium-country-pubs.png",
    "/brand-logos/sizzling-pubs.png",
    "/brand-logos/sons-of-steak.png",
    "/brand-logos/stonehouse.png",
    "/brand-logos/toby-carvery.png",
    "/brand-logos/vintage-inns.png",
  ]

  const settings = {
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <div className={`relative md:pr-[250px] bg-white`}>
      <Slider {...settings} className="bg-white">
        {logos.map((logo, index) => {
          return (
            <div key={index} className="flex h-full items-center py-8 px-6">
              <img
                src={logo}
                alt="Brand Logo"
                className={`aspect-[2] object-center object-contain w-full`}
              />
            </div>
          )
        })}
      </Slider>
      <div class="logo-plus md:absolute md:pt-0 bottom-0 md:w-[250px] top-0 right-0 bg-white flex items-center justify-center">
        <span
          className={`text-blue text-lg text-center pb-4 md:pt-0 md:text-3xl`}
        >
          +100s MORE
        </span>
      </div>
    </div>
  )
}

export default LogoStream
